__webpack_require__.p = "https://tastermpoint-mfe-support-cdt.maersk.io/mfe/support/";